/** @module Enums */ /** typedoc */
var StateUploadingAndSamplingEnum;
(function (StateUploadingAndSamplingEnum) {
    StateUploadingAndSamplingEnum["Created"] = "Created";
    StateUploadingAndSamplingEnum["Uploading"] = "Uploading";
    StateUploadingAndSamplingEnum["Uploaded"] = "Uploaded";
    StateUploadingAndSamplingEnum["Sampling"] = "Sampling";
    StateUploadingAndSamplingEnum["Available"] = "Available";
    StateUploadingAndSamplingEnum["Failed"] = "Failed";
})(StateUploadingAndSamplingEnum || (StateUploadingAndSamplingEnum = {}));
var StateUploadingAndPreparingEnum;
(function (StateUploadingAndPreparingEnum) {
    StateUploadingAndPreparingEnum["Created"] = "Created";
    StateUploadingAndPreparingEnum["Uploading"] = "Uploading";
    StateUploadingAndPreparingEnum["Uploaded"] = "Uploaded";
    StateUploadingAndPreparingEnum["Preparing"] = "Preparing";
    StateUploadingAndPreparingEnum["Available"] = "Available";
    StateUploadingAndPreparingEnum["Failed"] = "Failed";
})(StateUploadingAndPreparingEnum || (StateUploadingAndPreparingEnum = {}));
var StateSamplingEnum;
(function (StateSamplingEnum) {
    StateSamplingEnum["Created"] = "Created";
    StateSamplingEnum["Sampling"] = "Sampling";
    StateSamplingEnum["Available"] = "Available";
    StateSamplingEnum["Failed"] = "Failed";
})(StateSamplingEnum || (StateSamplingEnum = {}));
var StateMasteringEnum;
(function (StateMasteringEnum) {
    StateMasteringEnum["Created"] = "Created";
    StateMasteringEnum["Mastering"] = "Mastering";
    StateMasteringEnum["Available"] = "Available";
    StateMasteringEnum["Failed"] = "Failed";
})(StateMasteringEnum || (StateMasteringEnum = {}));
var StateTranscodingEnum;
(function (StateTranscodingEnum) {
    StateTranscodingEnum["Created"] = "Created";
    StateTranscodingEnum["Transcoding"] = "Transcoding";
    StateTranscodingEnum["Available"] = "Available";
    StateTranscodingEnum["Failed"] = "Failed";
})(StateTranscodingEnum || (StateTranscodingEnum = {}));
var StatePendingEnum;
(function (StatePendingEnum) {
    StatePendingEnum["Created"] = "Created";
    StatePendingEnum["Pending"] = "Pending";
    StatePendingEnum["Available"] = "Available";
    StatePendingEnum["Failed"] = "Failed";
})(StatePendingEnum || (StatePendingEnum = {}));

export { StateMasteringEnum, StatePendingEnum, StateSamplingEnum, StateTranscodingEnum, StateUploadingAndPreparingEnum, StateUploadingAndSamplingEnum };
